import React, { Component } from 'react';
import config from '../config';

import GoogleTagManager from './components/GoogleTagManager';
import Loader from './components/Loader';
import Header from './components/Header';
import Ankle from './components/Ankle';
import Footer from './components/Footer';
import Cookie from './components/Cookie';

class Layout extends Component {
	componentDidMount() {

		// if (window.innerWidth < 768) {
		// 	const htmlClass = document.documentElement.className;
		// 	document.documentElement.className = htmlClass.replace('no-mobile', 'mobile');
		// }

		const isMobile = navigator.userAgent.toLowerCase()
			.match(/(iphone|ipod|ipad|android|blackberry|opera mini|iemobile|kindle|silk|mobile)/);
		if (isMobile) {
			const htmlClass = document.documentElement.className;
			document.documentElement.className = htmlClass.replace('no-mobile', 'mobile');

			// const viewport = document.getElementsByName('viewport')[0];
			// const viewportContent = viewport.getAttribute('content');
			// const updateViewport = function() {
			// 	if (global.matchMedia('(min-width: 768px)').matches) {
			// 		viewport.setAttribute('content',viewportContent.replace('device-width',1366));
			// 	} else {
			// 		viewport.setAttribute('content', viewportContent);
			// 	}
			// };
			// window.addEventListener('orientationchange, deviceorientation', updateViewport, false);
			// updateViewport();
		}
	}

	getSignUpFormConfigDataByUri(currentUri) {
		switch (currentUri) {
			case "-----/learn/fire-and-water-safes":
				return {
					elqFormName: "copyUntitledForm-1601930314823-638211267093401152",
					title: "Be the First to Know",
					subtitle: "Sign up here to be the first to know when our new fireproof safes become available.",
					disclaimer: "By submitting this form, you are opting in to receive emails about the latest updates from SentrySafe. Only customers in the U.S. will receive these emails.",
					successMessage: `Thanks for signing up for updates from SentrySafe. <a href="http://eloquamarketing.masterlock.com/SentrySafe" target="_blank">Set your preferences</a>.`
				}
			default:
				return {
					elqFormName: "UntitledForm-1601930314823",
					title: "Sign up for updates and Offers from SentrySafe",
					subtitle: `New subscribers <strong>get 10% off</strong> your next purchase on the SentrySafe store.`,
					disclaimer: "*Only customers in the U.S. will receive these emails from SentrySafe. Discount applies to items shipped within the contiguous United States only.",
					successMessage: `Thanks for signing up for updates from SentrySafe. Please check your email for your exclusive discount code. <a href="http://eloquamarketing.masterlock.com/SentrySafe" target="_blank">Set your preferences</a>.`
				}
		}
	}

	render() {
		const { children, location } = this.props;

		return (
			<div>
				<GoogleTagManager gtmId={config.gtmId} />
				<Loader />
				<Cookie />
				<div className="container">
					<Header />
					<main id="content">
						{children}
					</main>
					{location.pathname !== "/lock-it-in" &&
						<Ankle formConfig={this.getSignUpFormConfigDataByUri(location.pathname)} />}
					<Footer />
				</div>
			</div>
		);
	}
}

export default Layout;


// WEBPACK FOOTER //
// ./src/pages/Layout.js